import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Svg from '../svgIcon';
import './styles.scss';

const Spinner = ({ visible, className, children, spinnerIconName }) => {
    if (!visible) {
        return null;
    }
    return (
        <div className={classNames('bs-spinner', className)}>
            <Svg
                iconName={spinnerIconName}
                size="2XL"
                className="bs-spinner__animatedWheel"
            />
            <span className="bs-spinner__text">
                {children}
            </span>
        </div>
    );
};

Spinner.defaultProps = {
    className: '',
    children: null,
    visible: true,
    spinnerIconName: 'spinner',
};

Spinner.propTypes = {
    visible: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.string,
    spinnerIconName: PropTypes.string,
};

export default Spinner;



// WEBPACK FOOTER //
// /src/js/common/spinner/Spinner.jsx